@if (skjemakontroll().length > 0) {

  <div class="antall-valgt" [class.antall-valgt__ingen]="ingenValgt()">
    <span>
      {{ antallValgt() }}/{{ skjemakontroll().length }} {{ "valgt"|translate }}
    </span>
  </div>

  <table>
    <tr>
      <th class="valgt">
        <mat-checkbox (click)="endreAlle()" [indeterminate]="!alleValgt() && !ingenValgt()" [checked]="alleValgt()" matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}"/>
      </th>
      <th class="valgt-tittelrad" colspan="3" (click)="endreAlle()" matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}">{{ "Medlem"|translate }}</th>
      @if (ekstraThInnhold() != null) {
        <th>
          <ng-container *ngTemplateOutlet="ekstraThInnhold()!; context: { item: antallValgt() }"></ng-container>
        </th>
      }
    </tr>
    @for (rad of skjemakontroll().controls; track rad.value.medlem!.id;) {
      <tr class="deltaker e2e-deltaker" (click)="endreValgt(rad)" data-testid="medlem">
        <td class="valgt">
          <mat-checkbox [formControl]="rad.controls.valgt" class="e2e-deltar" (click)=" $event.stopPropagation()" [aria-label]="rad.value.medlem!.navn" data-testid="medlem-valgt"/>
        </td>
        <td>
          <avatar stil="liten" [medlem]="rad.value.medlem!" [skjulTooltip]="true"/>
        </td>
        <td class="navn e2e-navn" data-testid="medlem-navn">{{ rad.value.medlem!.navn }}</td>
        <td class="rolle">{{ aktiveMedlemsroller(rad) }}</td>
        @if (ekstraTdInnhold() != null) {
          <td>
            <ng-container *ngTemplateOutlet="ekstraTdInnhold()!; context: { rad: rad }"></ng-container>
          </td>
        }
      </tr>
    }
  </table>

} @else {

  <tips>
    <span>{{ "Gruppen inneholder ingen medlemmer"|translate }}. <!--@todo lage en bedre melding--></span>
  </tips>
}
